import type {ReactNode} from 'react'

interface OrderHeaderBadgeProps {
    title: string
    children: ReactNode
}

const OrderHeaderBadge = ({title, children}: OrderHeaderBadgeProps) => (
    <div className="flex min-h-[60px] flex-col justify-center gap-sm rounded-md bg-white px-4 py-2">
        <p className="text-xs text-gray-400">{title}</p>
        <div className="text-xs font-medium text-gray-700">{children}</div>
    </div>
)

export default OrderHeaderBadge
